<template>
  <div id="app" class="pr" >
    <router-view class="router-view" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    };
  },
  computed: {
  },
  async mounted(){
  },
  methods:{
   
  },
  watch:{}
}
</script>

<style>
@import "assets/css/common.css";
@import "assets/css/style.css";
@import "assets/css/components.css";

.el-message{z-index:99999999 !important}
</style>
  



// WEBPACK FOOTER //
// src/App.vue